import { Pipe, PipeTransform } from '@angular/core';
import { ReviewClassification } from '../models/release';

@Pipe({
  name: 'reviewClassificationDisplay',
  standalone: false,

})
export class ReviewClassificationDisplayPipe implements PipeTransform {
  transform(value: ReviewClassification | string): string {

    if (typeof value === 'string' && (value in ReviewClassification)) {
      value = ReviewClassification[value as keyof typeof ReviewClassification];
    }

    switch (value) {
      case ReviewClassification.NeedsReview:
        return 'Needs Review';
      case ReviewClassification.Reviewed:
        return 'Reviewed';
      case ReviewClassification.AzureIssue:
        return 'Azure Issue';
      case ReviewClassification.ADOIssue:
        return 'ADO Issue';
      case ReviewClassification.CloudflareIssue:
        return 'Cloudflare Issue';
      case ReviewClassification.TestsIssue:
        return 'Tests Issue';
      case ReviewClassification.OtherIssue:
        return 'Other Issue';
      default:
        return value;
    }
  }
}
